import React, { useState, useEffect, useRef } from 'react';
import Link from 'next/link';
import dynamic from 'next/dynamic';
const Select = dynamic(() => import('react-dropdown-select'), { loading: () => <></> });
const PhoneInput = dynamic(() => import('react-phone-input-2'), { loading: () => <></> });
// import 'react-phone-input-2/lib/style.css';
import { initiateRegistration } from "../../../api/register";
import { RegisterationDone } from "../../../store/actions/registeration";
import Store from '../../../store';

import Facebook from '../../common/scoialLogins/facebook';
import Google from '../../common/scoialLogins/google';
import Apple from '../../common/scoialLogins/apple';


import { useDispatch } from "react-redux";
import { useRouter } from 'next/router';
// import { toastr } from 'react-redux-toastr';
// import "./style.scss"

function Registration(props) {
	const { userAuth } = Store.getState();
		
	const setPrograms = () => {
		let programs = [];
		if (props.programs && Object.keys(props.programs).length) {
			programs = props.programs.data.map((item) => {
				return { id: item.id, label: item.title, value: item.title.replace(/ /g, "_").toLowerCase() };
			});
		}
		
		return programs;
	}
	const setHeardSources = () => {
		let sources = [];
		if (props.sources && Object.keys(props.sources).length) {
			sources = props.sources.data.map((item) => {
				return { id: item.id, label: item.title, value: item.title.replace(/ /g, "_").toLowerCase() };
			});
		}
		return sources;
	}
	const dispatch = useDispatch();
	const router = useRouter();
	const [nameValid, setNameValid] = useState('');
	const [phoneValid, setPhoneValid] = useState('');
	const [termsPolicy, setTermsPolicy] = useState('');
	const [programValid, setProgramValid] = useState('');
	const [hearValid, setHearValid] = useState('');
	
	const [registerForm, setRegisterForm] = useState({
		name: '',

		email: '',
		emailValid: '',

		password: '',
		passwordValid: '',

		showPassword: false,

		phone: '',

		programId: router.query?.isSubscribe == "true" ? 7 : null,
		programs: setPrograms(),

		hearId: null,
		hearFrom: setHeardSources(),//[{ id: 1, label: 'Word Of Mouth', value: 'word-of-mouth' }, { id: 2, label: 'Friend', value: 'friend' }, { id: 3, label: 'Online Add', value: 'online-add' }],

		loading: false,
		source: null,
	});

	useEffect(()=>{
		if (userAuth.token) {
			window.location.href = '/home';
		}
	}, []);
	
	useEffect(() => {
			validate('password');
	}, [registerForm.password]);
	
	const validate = (field) => {
		let regex;
		let value = registerForm[field];
		switch (field) {
			case 'name':
				regex = /^.{2,}/;
				setNameValid(regex.test(value));
				break;
			case 'email':
				regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
				setRegisterForm(registerForm => ({ ...registerForm, [field + "Valid"]: regex.test(value) }));
				break;
			case 'password':
				regex = /^(?=[^\d_].*?\d)\w(\w|[!@#$%*]){7,20}/;
				setRegisterForm(registerForm => ({ ...registerForm, [field + "Valid"]: regex.test(value) }));
				break;
			case 'phone':
				regex = /^.{10,}/;
				// regex = /^\+(?:[0-9] ?){6,14}[0-9]$/;
				setPhoneValid(regex.test(value));
				break;
		}
	}

	const validateAll = () => {
		Object.keys(registerForm).forEach(field => validate(field));
		if (!!termsPolicy) {
			setTermsPolicy(true);
		} else {
			setTermsPolicy(false);
		}
		// @ts-ignore
		setProgramValid(registerForm.programId ? true : false);
		// @ts-ignore
		setHearValid(registerForm.hearId ? true : false);
		return validateForm();
	}

	const updateField = (field, val) => {
		setRegisterForm(registerForm => ({ ...registerForm, [field]: val }));
		validate(field);
	}

	const validateForm = () => {
		const { emailValid, passwordValid} = registerForm;
		return (!!nameValid && !!emailValid && !!phoneValid && !!passwordValid && !!programValid && !!hearValid && !!termsPolicy && !registerForm.loading);
	}

	const setValues = (propery, values) => {
		setRegisterForm(registerForm => ({ ...registerForm, [propery]: values[0].id}));
		if (propery == "programId") {
			document.getElementsByClassName("react-dropdown-select-input")[0].classList.add("register-hidden");
		}
		if (propery == "hearId") {
			document.getElementsByClassName("react-dropdown-select-input")[1].classList.add("register-hidden");
		}
	}

	const updatePhone = (phone) => {
		setRegisterForm(registerForm => ({ ...registerForm, phone }));
		validate('phone');
	}

	const signup = () => {
		if (validateAll()) {
			setRegisterForm(registerForm => ({ ...registerForm, loading: true }));
			let index = registerForm.name.lastIndexOf(' ');
			let first = registerForm.name, last = registerForm.name;
			if (index !== -1) {
				first = registerForm.name.substring(0, index);
				last = registerForm.name.substring(index + 1);
			}
			let data = {
				first_name: first, 
				last_name: last, 
				email: registerForm.email,
				password: registerForm.password,
				phone_number: registerForm.phone,
				heard_source_id: registerForm.hearId,
				program_id: registerForm.programId,
				terms: termsPolicy
				// signup_source_id: registerForm.source,
			}
			initiateRegistration(data).then((res) => {
			
				if (Object.keys(res).length) {
					if (res.next_step === 1) {
						// router.push('/register/email-verification', "/email-verification", { shallow: true });
						// authenticated: false,
						dispatch(RegisterationDone({ id: res.user_id, email: registerForm.email, token: res.auth_token, name: registerForm.name, isNewUser: true, authenticated: true, profile: res.user?.profile }));
					}
					// } else if (res.next_step === 2) {
					// 	dispatch(RegisterationDone({ id: res.user_id, email: registerForm.email, source: registerForm.source, token: res.auth_token, isNewUser: true, authenticated: true}));
					// }
					router.push('/register/select-gender', "/select-gender", { shallow: true });
				}
				setRegisterForm({ ...registerForm, loading: false });
			});
		}
	}

	return (
		<div className="register">
			<a onClick={() => {window.location.href = "/"}} className="page-close"></a>
			<div className="wrapper">
				<div className="box">
					<h1>Sign up for Bayan</h1>
					<div className="inner-box">
						<div className="signup-name-fields field">
							<div className="name-field">
								<input id="_name" name="name" type="text" className={"is-input " + (nameValid === false ? 'input-err' : nameValid === true ? 'input-valid' : '')}
									placeholder="First & last name" value={registerForm.name} onBlur={(e) => updateField('name', e.target.value)} onChange={(e) => updateField('name', e.target.value)} />
								{nameValid === false && <small className='err-msg'>*Must enter a valid Name.</small>}
							</div>
						</div>

						<div className="field">
							<input id="_email" name="email" type="email" className={"is-input email-field " + (registerForm.emailValid === false ? 'input-err' : registerForm.emailValid === true ? 'input-valid' : '')}
								placeholder="Email" value={registerForm.email} onBlur={(e) => updateField('email', e.target.value)} onChange={(e) => updateField('email', e.target.value)} />
							{registerForm.emailValid === false && <small className='err-msg'>*Must enter a valid Email.</small>}
						</div>

						<div className="password-field field">
							<input id="_password" name="password" type={registerForm.showPassword ? "text" : "password"} className={"is-input " + (registerForm.passwordValid === false ? 'input-err' : registerForm.passwordValid === true ? 'input-valid' : '')}
								placeholder="Password" value={registerForm.password} onBlur={(e) => updateField('password', e.target.value)} onChange={(e) => updateField('password', e.target.value)} />
							<div className="login-show-pass" onClick={() => setRegisterForm(registerForm => ({ ...registerForm, showPassword: !registerForm.showPassword }))}>
								{registerForm.showPassword ? <i className="fas fa-eye eye"></i> : <i className="fas eye fa-eye-slash"></i>}
							</div>
							{registerForm.passwordValid === false && <small className='err-msg'>{"*Password must follow these requirements:\n8-20 letters and numbers\nMust start with a letter\nMust container at least one number"}</small>}
						</div>

						<div style={{position: "relative"}}>
							<PhoneInput
								country={'us'}
								value={registerForm.phone}
								inputClass={phoneValid === false ? 'input-err' : (phoneValid === true ? 'input-valid' : '')}
								onChange={phone => updatePhone(phone)}
							/>
							{phoneValid === false && <small className='err-msg' style={{ position: 'absolute', top: '30px', border: '9', left: '0'}}>*Must enter a valid Number.</small>}
						</div>
						<Select 
							alt="Bayan On-Demand"
							options={registerForm.programs} 
							multi={false}
							placeholder={router.query?.isSubscribe == "true" ? "Bayan On-Demand" : "What program are you interested in"}
							dropdownGap={3}
							className={`program-dropdown select-field ${programValid === false ? 'input-err' : ''}`}
							dropdownHeight="300px"
							style={{color: 'black'}}	
							onChange={(values) => { setValues("programId", values);  setProgramValid(true);}} />
						{programValid === false && <small className='err-msg' style={{ position: 'relative', top: '-20px', display: 'flex' }}>{"Please select progams you are intrested in."}</small>}

						<Select
							options={registerForm.hearFrom}
							multi={false}
							placeholder="How did you hear about Bayan?"
							dropdownGap={3}
							className={`program-dropdown select-field ${hearValid === false ? 'input-err' : ''}`}
							dropdownHeight="300px"
							style={{ color: 'black' }}
							onChange={(values) => { setValues("hearId", values); setHearValid(true);}} />
						{hearValid === false && <small className='err-msg' style={{ position: 'relative', top: '-20px', display: 'flex' }}>{"Please select How did you hear about Bayan."}</small>}
						<div className={`field-check ${termsPolicy === true ? "input-valid checkbox" : termsPolicy === false ? "input-err checkbox" : ''}`}>
							<label className="checkbox-w">I agree to Bayan's <a target="_blank" href="/privacy-policy">Privacy Policy</a> and <a target="_blank" href="/terms-of-service">Terms of Use</a>
								<input type="checkbox" name="lsRememberMe" checked={termsPolicy} onChange={(e) => setTermsPolicy(e.target.checked)} />
								<span className="checkmark"></span>
							</label>
						</div>
						{/* <div className={"login-btn " + ((validateForm()) ? '' : 'disabled')} onClick={() => signup()}> */}
						<div className={`login-btn ${termsPolicy == true ? '' : 'disabled'}`} onClick={() => signup()}>
							Sign Up
							{registerForm.loading && <img src={`/icons/loading.svg`} style={{ height: '25px' , marginLeft: '10px' }} />}
						</div>

						<Link href="/login" as="/login">
							<a>Already have an account?</a>
						</Link>
						<p>Or sign up with</p>
					</div>
					<div className="login-third-party">
						<div className="login-round-btn"><Facebook /></div>
						<div className="login-round-btn"><Google  /></div>
						{/* <div className="login-round-btn apple-login"> */}
							{/* <Apple /> */}
							{/* <img src={`${process.env.IMAGES_BASE_URL}/static-content/apple.png.webp`} alt='apple-logo' /> */}
						{/* </div> */}
					</div>
				</div>
			</div>
		</div>
	);
};

export default Registration;
